<template>
  <div class="hello">
    <h1>(404) Page Not Found</h1>
  </div>
</template>

<script lang="ts">
export default {};
</script>
